export class MonthlyActionsRow {
    public MonthLabel: string = '';
    public ActionsRaised: number = 0;
    public ActionsCompleted: number = 0;
    public ActionsCompletedOnTime: number = 0;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
